export const HOME_I18N_ENTRIES = {
  home_Data1: {
    es: '<span>Cerrando la brecha entre la <span class="billion-orange">Educación</span> y el <span class="billion-orange">Mundo real</span></span>',
    en: '<span></span>',
    pt: '<span></span>',
    fr: '<span></span>',
    eus: '<span></span>',
    cat: '<span></span>',
  },
  home_Data2: {
    es: '<p>Formamos a los jóvenes en las habilidades necesarias para enfrentar los desafíos del futuro.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data3: {
    es: '<p>Únete a la revolución educativa</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data4: {
    es: '<p>“La <span class="billion-green">paradoja</span> del talento”</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data5: {
    es: '<p class="billion-orange">Problema</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data6: {
    es: '<p class="billion-green">Solución</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data7: {
    es: '<p>Vivimos con la generación “<span class="i18n-bold">más formada de la historia</span>”. Sin embargo, al hablar con las empresas, descubrimos que nunca antes habían tenido tantas dificultades para encontrar talento adecuado. Paralelamente, los jóvenes, pese a estar más formados que nunca, enfrentan enormes desafíos para encontrar empleo</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data8: {
    es: '<p>Por este motivo nace <span class="i18n-bold">(Smart)Makings</span>. Conectamos centros educativos con empresas para cerrar la brecha entre la educación y el mundo laboral, asegurando que los jóvenes adquieran no solo conocimientos, sino también las competencias necesarias para triunfar en sus carreras y vidas personales.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data9: {
    es: '<p><span class="billion-orange">Experimenta.</span> Aprende</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data10: {
    es: '<p>En <span class="i18n-bold">(Smart)Makings</span>, hemos identificado que las habilidades y competencias que realmente te hacen destacar no se aprenden en un libro, sino a través de la experiencia. Es por eso que hemos adoptado el enfoque de "aprender viviendo".</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data11: {
    es: '<p>Nuestra metodología innovadora pone a los alumnos en el centro de situaciones cruciales de la vida real, esas que inevitablemente tendrán que enfrentar tarde o temprano. En lugar de esperar a que la vida les enseñe, adelantamos esos momentos clave para que los estudiantes tomen decisiones, enfrenten consecuencias y aprendan de ellas en un entorno controlado y seguro.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data12: {
    es: '<p>Al hacerles vivir estas experiencias ahora, los preparamos para que, cuando se enfrenten a situaciones similares en la vida real, ya tengan una base sólida y entrenada. De este modo, no solo desarrollan habilidades, sino que también ganan confianza y seguridad para afrontar cualquier desafío que se les presente.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data13: {
    es: '<p>Con este enfoque, transformamos la educación en una experiencia verdaderamente práctica y relevante, que les da a los jóvenes la ventaja que necesitan para sobresalir en el mundo real.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data14: {
    es: '<p>¿Qué hacemos?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data15: {
    es: '<p>Itinerario %X%</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data16: {
    es: '<p>(%X% sesiones de 50 min)</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data17: {
    es: '<p>Empezar</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data18: {
    es: '<p>Desarrollo Personal</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data19: {
    es: '<p>Competencia Digital</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data20: {
    es: '<p>Habilidades Financieras</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data21: {
    es: '<p>Habilidades interpersonales</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data22: {
    es: '<p>Desarrollo profesional</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data23: {
    es: '<p>Ética y valores</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data24: {
    es: '<p>Toma de decisiones</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data25: {
    es: '<p>Gestión del tiempo</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data26: {
    es: '<p>Comunicación y oratoria</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data27: {
    es: '<p>Ciencia ambiental y cultural</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data28: {
    es: '<p>¿Cómo lo trabajamos?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data29: {
    es: '<p>Sesiones de</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data30: {
    es: '<p class="i18n-bold">Las habilidades que realmente marcan la diferencia se desarrollan viviendo experiencias, no solo escuchándolas.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data31: {
    es: '<p>Por eso, hemos creado un enfoque educativo basado en la experiencia directa y la toma de decisiones en situaciones de la vida real.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data32: {
    es: '<p>A través de sesiones inmersivas que simulan desafíos reales, ayudamos a los estudiantes a no solo adquirir conocimientos, sino también a desarrollar las competencias esenciales para su futuro.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data33: {
    es: '<p><span class="i18n-bold">Introducción:</span> Presentamos la sesión y el caso de estudio, preparando a los estudiantes para el desafío que enfrentarán.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data34: {
    es: '<p><span class="i18n-bold">Experiencia:</span> Los estudiantes se sumergen en situaciones reales, tomando decisiones y enfrentando las consecuencias.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data35: {
    es: '<p><span class="i18n-bold">Debate:</span> Guiamos un debate reflexivo donde los estudiantes comparten sus experiencias y aprendizajes, consolidando sus conocimientos.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data36: {
    es: '<p>¿Eres tú, nuestro \n <span class="billion-orange">próximo aliado?</span></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data37: {
    es: '<p>El programa de <span class="i18n-bold">(Smart)Makings</span> está diseñado específicamente para aquellos centros educativos que buscan ir más allá de la enseñanza tradicional y preparar a sus estudiantes para los desafíos reales del mundo laboral y personal. Nuestro enfoque está dirigido a:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data38: {
    es: '<p class="i18n-bold">· Centros de Educación Secundaria Obligatoria (ESO) y Bachillerato</p><p class="i18n-bold">· Centros de Formación Profesional (FP)</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data39: {
    es: '<p>Si eres un centro comprometido con el futuro de tus estudiantes, únete a nosotros y convierte la experiencia en el eje central de la educación. ¡Prepara a tus alumnos para la vida real con <span class="i18n-bold">(Smart)Makings!</span></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data40: {
    es: '<p>¡Suma tu centro al cambio!</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data41: {
    es: '<p>Una oportunidad para \n <span class="billion-orange">empresas y centros educativos</span></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data42: {
    es: '<p>Nuestras soluciones educativas no solo benefician a los estudiantes, sino también a las empresas que participan como patrocinadoras. Involúcrate en la educación de la próxima generación y ayuda a cerrar la brecha entre la educación y el mundo laboral.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data43: {
    es: '<p>Centros Educativos</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data44: {
    es: '<p>Los programas son implementados sin coste para los centros educativos, gracias al apoyo de nuestras empresas patrocinadoras.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data45: {
    es: '<p>¡Suma tu centro al cambio!</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data46: {
    es: '<p>Empresas Patrocinadoras</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data47: {
    es: '<p>Fortalece tu lazo con la comunidad educativa y contribuye a la formación de futuros talentos</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data48: {
    es: '<p>¡Conviertéte en patrocinador!</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data49: {
    es: '<p>¿Quiénes confían ya en nosotros?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  home_Data50: {
    es: '<p>min</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
};
